const YearRangeField = ({
  label,
  fromYear,
  toYear,
  onFromYearChange,
  onToYearChange
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 30 }, (_, i) => currentYear - i);

  return (
    <div className="multi-select-field">
      <label>{label}:</label>
      <div className="year-range-container" style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
        <select
          className="multi-select-input-wrapper"
          style={{ flex: 1, cursor: 'pointer' }}
          value={fromYear || ""}
          onChange={(e) => onFromYearChange(e.target.value)}
        >
          <option value="">From Year</option>
          {years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <span style={{ color: '#666' }}>to</span>

        <select
          className="multi-select-input-wrapper"
          style={{ flex: 1, cursor: 'pointer' }}
          value={toYear || ""}
          onChange={(e) => onToYearChange(e.target.value)}
          disabled={!fromYear}
        >
          <option value="">To Year</option>
          {years
            .filter(year => !fromYear || year >= parseInt(fromYear))
            .map(year => (
              <option key={year} value={year}>{year}</option>
            ))}
        </select>
      </div>
    </div>
  );
};

export default YearRangeField;